import {
  styled,
  Dialog as MuiDialog,
  Typography,
  ButtonBase,
} from '@mui/material';

export const Dialog = styled(MuiDialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    maxWidth: '800px',
    padding: '0px 50px 50px 50px',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: '20px',
  },
  [theme.breakpoints.down('md')]: {
    '& .MuiDialog-paper': {
      padding: '0px 24px 24px 24px',
      borderRadius: '16px',
      flexDirection: 'column',
      gap: '32px',
    },
    '& .MuiDialog-container': {
      alignItems: 'flex-end',
    },
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiDialog-paper': {
      margin: '16px',
    },
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '28px',
  fontWeight: '600',
  textAlign: 'center',
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
  },
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: '400',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
  },
}));

export const RefreshButton = styled(ButtonBase)(({ theme }) => ({
  padding: '8px 16px 8px 8px',
  backgroundColor: theme.palette.primary.main,
  gap: '8px',
  borderRadius: '25px',
  fontSize: '14px',
  fontWeight: '500',
  color: theme.palette.common.white,
}));
